import { useCallback, useState } from 'react';
import { Notification } from 'services/notifications/types';

type usePaginationReturn<T> = {
  resultPerPage: T[];
  totalResultsCount: number;
  currentPage: number;
  onPageChange;
  paginate: (results: T[]) => void;
};

export const usePagination = <T extends object>(
  itemsPerPage: number,
  toggleValue: boolean
): usePaginationReturn<T> => {
  const [totalResults, setTotalResults] = useState([]);
  const [totalResultsCount, setTotalResultsCount] = useState(0);
  const [resultPerPage, setResultPerPage] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const paginate = useCallback(
    (results: Array<T>) => {
      const notificationsByToggle = toggleValue
        ? results
        : results.filter((item) => !(item as Notification).isDismissed);
      setTotalResults(results);
      setTotalResultsCount(notificationsByToggle.length);
      setResultPerPage(notificationsByToggle.slice(0, itemsPerPage));
      setCurrentPage(1);
    },
    [itemsPerPage, toggleValue]
  );

  const onPageChange = useCallback(
    (currentPage: number) => {
      const begin = (currentPage - 1) * itemsPerPage;
      const end = begin + itemsPerPage;
      const totalNotificationByToggle = toggleValue
        ? totalResults
        : totalResults.filter((item) => !(item as Notification).isDismissed);
      setResultPerPage(totalNotificationByToggle.slice(begin, end));
      setCurrentPage(currentPage);
    },
    [itemsPerPage, totalResults, toggleValue]
  );

  return {
    resultPerPage,
    totalResultsCount,
    currentPage,
    onPageChange,
    paginate
  };
};
